
export class FunctionSummaryModel {
    public id: number;
    public name: string;
    public categoryName: string;
    public routePath: string;
    public pageTitle: string;
    public pageSubtitle: string;
}